import React from 'react'
import { IPlaylistScript } from '@/types/cinematics'
import { IPlaylistActorScript } from './types'
import { Playlist } from './client/PlaylistComponent'

import classes from './client/styles.module.scss'

interface PlaylistActorProps {
  script: IPlaylistActorScript
}
export const PlaylistActor = (props: PlaylistActorProps) => {
  const { script } = props
  const playlistScripts = (script?.playlists || []).filter(playlist => !playlist.hidden)

  return (
    <section className={classes.ottHome}>
      {playlistScripts.map((playlist: IPlaylistScript) => (
        <Playlist
          key={playlist._id}
          playlistScript={playlist}
        />
      ))}
    </section>
  )
}